import { api } from "../../../api/axiosInstance";
import type { CreateProfileAddressRequest } from "../../common/ts";
import type {
  ChangePasswordFormValues,
  PatchUserProfile,
  // PatchAccount,
  WithdrawRequest,
  // AccessCalendarRequest,
  // UpdateCalendarRequest,
  // CreatePetRequest,
  UpdatePetRequest,
  AboutMeFormValues,
  CreatePetRequest,
  PresignUrlRequestPayload,
  SendOtpRequest,
  VerifyOtpRequest,
  ContactPreferenceRequest,
  UpdateNotificationPreferenceRequest,
} from "../ts";

export const accountSettingsAPI = {
  getUserProfile() {
    return api.get("/api/v1/users/profile/");
  },
  getFullUserProfile() {
    return api.get("/api/v1/users/profile/full");
  },
  changePassword(request: ChangePasswordFormValues) {
    return api.post("/api/v1/users/profile/change-password/", request);
  },
  patchSitterProfile(request: PatchUserProfile) {
    return api.patch("/api/v1/users/profile/", request);
  },
  updateAboutMeThunk(request: AboutMeFormValues) {
    return api.patch("/api/v1/users/profile/me", request);
  },
  getWalletBalance() {
    return api.get("/api/v1/payments/wallet/balance/");
  },
  withdraw(request: WithdrawRequest) {
    return api.post("/api/v1/payments/earnings/withdraw/", request);
  },
  // accessCalendar(request: AccessCalendarRequest) {
  //   return api.post("/api/v1/users/calendar/", request);
  // },
  // getCalendar() {
  //   return api.get("/api/v1/users/calendar/");
  // },
  // deleteCalendar() {
  //   return api.delete("/api/v1/users/calendar/");
  // },
  // updateCalendar(request: UpdateCalendarRequest) {
  //   return api.patch("/api/v1/users/calendar/", request.formData);
  // },
  sendOtp: (data: SendOtpRequest) =>
    api.post(`/api/v1/users/profile/phone/send-otp`, data),

  verifyOtp: (data: VerifyOtpRequest) =>
    api.post(`/api/v1/users/profile/phone/verify-otp`, data),

  updateContactPreference: (data: ContactPreferenceRequest) =>
    api.post(`/api/v1/users/profile/phone/contact-preferences`, data),

  createPet(request: CreatePetRequest) {
    return api.post("/api/v1/users/pets/", request);
  },
  getPets() {
    return api.get("/api/v1/users/pets/");
  },
  getPetById(petId: string) {
    return api.get(`/api/v1/users/pets/${petId}/`);
  },
  deletePet(petId: string) {
    return api.delete(`/api/v1/users/pets/${petId}/`);
  },
  updatePet(request: UpdatePetRequest) {
    return api.put(`/api/v1/users/pets/${request.id}/`, request);
  },
  searchAddress(postalCode: string) {
    return api.get(`/api/v1/data/address/search/${postalCode}/`);
  },
  createProfileAddress(request: CreateProfileAddressRequest) {
    return api.post("/api/v1/users/profile/addresses/", request);
  },
  createDocPresignUrlForPet(
    pet_id: string,
    requestData: PresignUrlRequestPayload,
  ) {
    return api.post(`/api/v1/users/pets/${pet_id}/file/presign/`, requestData);
  },
  createDocPresignUrlForProfile(requestData: PresignUrlRequestPayload) {
    return api.post(`/api/v1/users/profile/file/presign/`, requestData);
  },
  updateNotificationPreference(
    requestData: UpdateNotificationPreferenceRequest,
  ) {
    return api.patch(
      `/api/v1/users/profile/notification-preferences/`,
      requestData,
    );
  },
};
